import fonts from "./fonts"

/*
 * Parking-flow design tokens ("Aetheric Intelligence" system).
 * Parking-scoped ONLY — consumed as `props.theme.parking.*`.
 * Does NOT mutate the shared theme defaults (colors/fonts/radius/shadow)
 * used by the rest of the app, so non-parking ad surfaces are unaffected.
 *
 * Fonts intentionally reuse the master Avenir stack — no self-hosted font
 * files (Hanken Grotesk / JetBrains Mono / Material Symbols) are loaded in
 * this step. `grotesk`/`mono`/`symbols` all alias the master input font so
 * components authored against the mockup tokens compile unchanged.
 */
export default {
  colors: {
    bg: '#faf8ff',
    surface: '#faf8ff',
    surfaceLowest: '#ffffff',
    surfaceLow: '#f2f3ff',
    surfaceContainer: '#eaedff',
    surfaceHigh: '#e2e7ff',
    surfaceDim: '#d2d9f4',

    primary: '#0050cb',
    primaryContainer: '#0066ff',
    primaryFixed: '#dae1ff',
    primaryFixedDim: '#b3c5ff',

    onSurface: '#131b2e',
    onSurfaceVariant: '#424656',
    outline: '#727687',
    outlineVariant: '#c2c6d8',
    error: '#ba1a1a'
  },
  fonts: {
    grotesk: fonts.avenirNextMedium,
    mono: fonts.avenirNextMedium,
    symbols: fonts.avenirNextMedium
  },
  radius: {
    sm: '6px',
    md: '8px',
    md2: '10px',
    lg: '12px',
    xl: '16px',
    pill: '9999px'
  }
}
